<template>
	<div class="result highlighted-content">
		<template v-if="isColumnsMode">
			<h3 v-if="statusAnswer === 'win'" class="text-success">
				{{
			'Congratulations! You did it! Now you can go to the following exercises'
			| translate
		}}
			</h3>
			<table class="table table-bordered">
				<tbody>
					<tr>
						<th>{{ notHomework ? 'games.columns.user' : '№' | translate }}</th>
						<th>{{ 'ANSWER' | translate }}</th>
						<th>{{ 'right' | translate }} / {{ 'wrong' | translate }}</th>
						<th>{{ 'Time' | translate }}</th>
					</tr>
					<tr :key="result.time" v-for="(result, index) in columnResults">
						<td>{{ notHomework ? result.user : index + 1 }}</td>
						<td>{{ parseInt(result.answer) }}</td>
						<td :class="result.correct ? 'text-success' : 'text-danger'">
							{{ result.correct ? '&#10003;' : '❌' }}
						</td>
						<td>{{ result.time ? result.time / 1000 : 0 }}sec</td>
					</tr>
				</tbody>
			</table>
		</template>

		<template v-else>
			<template v-if="statusAnswer === 'win'">
				<h3 class="text-success">
					{{
			'Congratulations! You did it! Now you can go to the following exercises'
			| translate
		}}
				</h3>
				<h2 class="text-success">
					{{ 'RIGHT. ANSWER:' | translate }} {{ answer }}
				</h2>
			</template>
			<template v-else>
				<h2 class="text-danger">{{ 'NOT CORRECT' | translate }} :(</h2>
			</template>
		</template>

		<p v-show="showExpression">{{ expression }}</p>
		<button v-if="showTryAgain" class="btn btn-lg btn-success text-uppercase" @click="$emit('startGame')">
			{{ 'Try again' | translate }}
		</button>
		<button v-if="!isColumnsMode" class="btn btn-lg btn-primary text-uppercase"
			@click="showExpression = !showExpression">
			{{ 'expression' | translate }}
		</button>

		<button v-if="showNext" class="btn btn-lg btn-success text-uppercase" @click="$emit('loadGame', true)">
			{{ 'next' | translate }}
		</button>

		<button @click="$router.go(-1)" class="btn btn-lg btn-pink text-uppercase">
			{{ 'back' | translate }}
		</button>
	</div>
</template>

<script>
export default {
	name: 'result',
	data: () => ({
		showExpression: false,
	}),
	props: {
		isTrain: {
			type: Boolean,
		},
		answer: {
			type: String,
			required: true,
		},
		expression: {
			type: String,
			required: true,
		},
		showTryAgain: {
			type: Boolean,
			required: true,
		},
		notHomework: {
			type: Boolean,
			required: true,
		},
		columnResults: {
			type: Array,
		},
		isColumnsMode: {
			type: Boolean,
		},
		statusAnswer: {
			type: String,
			required: true,
		},
		currentExpression: {
			type: Number,
			required: true,
		},
		tasksLeft: {
			type: Number,
			required: true,
		},
	},
	computed: {
		showNext() {
			return (
				this.notHomework || (this.statusAnswer === 'win' && this.tasksLeft > 1)
			)
		},
		isCustomBgEnabled() {
			return !!this.$store.getters.primaryBackground
		},
	},
}
</script>

<style scoped lang="scss">
.result {
	width: fit-content;
	margin: auto;
	padding: 12px;

	&.highlighted-content {
		background: #fff;
		border-radius: 12px;
		border: 2px solid red;
		color: #e4467b;
	}
}

.result button {
	display: block;
	width: 260px;
	margin: 10px auto;
}

p {
	color: #f11a7c;
	font-size: 25px;
}

.result h2 {
	margin-bottom: 45px;
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	margin: 10px 0;
	width: 260px;
	cursor: pointer;
}

.btn-pink:hover {
	background-color: #e85183;
}
</style>
